import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { getPageURL, ROUTE_CONFIG } from 'services/hostPortal.service';
import { isAuthenticated } from 'services/identity.service';
import isProtectedRoute from 'services/security.service';

const WithAuth = ({ children }) => {
  const router = useRouter();
  const { pathname, asPath, isReady } = router;

  const isBrowser = typeof window !== 'undefined';
  const isNotAuthenticated = !isAuthenticated();
  const isAuthenticationNeeded =
    isBrowser && isProtectedRoute(pathname) && isNotAuthenticated;

  if (!isAuthenticationNeeded) {
    return children;
  }

  useEffect(() => {
    if (isReady && isAuthenticationNeeded) {
      const loginPageURLWithRedirectionInfo = getPageURL({
        pageName: ROUTE_CONFIG.LOGIN.label,
        queryParams: {
          redirectTo: encodeURIComponent(asPath)
        }
      });

      router.replace(loginPageURLWithRedirectionInfo);
    }
  }, [isReady]);

  return 'Loading...';
};

export default WithAuth;
